// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"b5d8a97b","205":"2fa3179f","276":"0aadb134","283":"70429250","407":"a30574b9","602":"31c47d10","615":"bd695f77","998":"24b0727b"}[chunkId] + ".chunk.js";
};